import { render } from "./PopoverSiniestro.vue?vue&type=template&id=91a7a428"
import script from "./PopoverSiniestro.vue?vue&type=script&lang=js"
export * from "./PopoverSiniestro.vue?vue&type=script&lang=js"

import "./PopoverSiniestro.vue?vue&type=style&index=0&id=91a7a428&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__